export default "__VITE_ASSET__DGNc$NcK__"